(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadHospitalizationDisease', LeadHospitalizationDisease);

    LeadHospitalizationDisease.$inject = ['$resource'];

    function LeadHospitalizationDisease ($resource) {
        var resourceUrl =  'api/lead-hospitalization-diseases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
